<template>
  <div>
    <background-wrapper :src="routeNameKebab + '/fullscreen-image_hero'" ext="png">
      <div class="hero">
        <text-container size="lg">
          <h1 class="h2" v-html="$t(`${$route.name}.hero.title`)"/>
          <p v-html="$t(`${$route.name}.hero.subtitle`)"/>
        </text-container>
      </div>
    </background-wrapper>
    <div class="posts">
      <div class="posts__header mb-1">
        <h2 class="posts__title">{{$t(`${$route.name}.articles`)}}</h2>
        <b-dropdown :text="currentYear ? currentYear.toString() : $t(`${$route.name}.all-articles`)" variant="outline-secondary" size="sm" right style="min-width: 220px">
          <b-dropdown-item :active="!currentYear" :to="{ ...$route, query: {} }">
            {{$t(`${$route.name}.all-articles`)}}
          </b-dropdown-item>
          <b-dropdown-item v-for="year of years" :key="year" :active="year === currentYear" :to="{ ...$route, query: { year } }">
            {{year}}
          </b-dropdown-item>
        </b-dropdown>
      </div>
      <div id="posts" class="posts__list">
        <Post v-for="post in postsPerPage" :post="post" :key="post.url"/>
      </div>
      <b-pagination-nav class="pagination" :link-gen="linkGen" :number-of-pages="numberOfPages" use-router>
        <template #first-text>
          <img src="@/assets/arrow-left-small.svg">
          <img src="@/assets/arrow-left-small.svg">
        </template>
        <template #prev-text>
          <img src="@/assets/arrow-left-small.svg">
        </template>
        <template #next-text>
          <img src="@/assets/arrow-right-small.svg">
        </template>
        <template #last-text>
          <img src="@/assets/arrow-right-small.svg">
          <img src="@/assets/arrow-right-small.svg">
        </template>
      </b-pagination-nav>
    </div>
  </div>
</template>

<script>
import { Post } from '@/components/ui/mediaArticles'

export default {
  name: 'MediaArticles',
  data () {
    return {
      postsData: [],
      perPage: 6
    }
  },
  beforeMount () {
    this.axios.get(`${process.env['CMS_DOMAIN']}/api/media/articles`)
      .then(data => {
        this.postsData = data.data.sort((a, b) => new Date(b.publishedDate) - new Date(a.publishedDate))
      })
      .catch(err => {
        console.log(err)
        this.postsData = []
      })
  },
  methods: {
    linkGen (pageNum) {
      const year = this.$route.query.year
      return {
        ...this.$route,
        query: {
          ...year && {
            year
          },
          ...pageNum !== 1 && {
            page: pageNum
          }
        }
      }
    }
  },
  computed: {
    years () {
      return [...new Set(this.postsData.map(post => new Date(post.publishedDate).getFullYear()))].sort((a, b) => b - a)
    },
    routeNameKebab () {
      return this.$toKebabCase(this.$route.name)
    },
    currentYear () {
      return +this.$route.query.year || 0
    },
    filteredPosts () {
      return this.postsData.filter(post => this.currentYear === new Date(post.publishedDate).getFullYear() || !this.currentYear)
    },
    currentPage () {
      return this.$route.query.page || 1
    },
    numberOfPages () {
      return Math.ceil(this.filteredPosts.length / this.perPage) || 1
    },
    postsPerPage () {
      return [...this.filteredPosts].splice((this.currentPage - 1) * this.perPage, this.perPage)
    }
  },
  components: { Post }
}
</script>

<style lang="sass" scoped>
.hero
  padding: 90px 0 140px
  +media-breakpoint-down(md)
    padding: 60px 0 100px
  +media-breakpoint-down(sm)
    padding: 50px 0 80px
  +media-breakpoint-down(xs)
    padding: 30px 0 80px

  .text-container
    text-align: left!important
    justify-items: start!important
    max-width: 550px
    +media-breakpoint-down(md)
      max-width: 400px
    +media-breakpoint-down(sm)
      max-width: 300px

.posts
  margin: 90px 0 120px

  &__header
    display: flex
    align-items: center
    justify-content: space-between

  &__title
    margin-bottom: 0
    margin-right: 20px
    font-size: 1rem
    text-transform: uppercase
    letter-spacing: .8px

  &__list
    border: solid 1px #B8BBC3
    border-left: 0
    border-right: 0

.pagination
  margin-top: 35px
  justify-content: center
</style>



// WEBPACK FOOTER //
// src/components/mediaArticles/MediaArticles.vue